'use strict'

import React, { useEffect, useState } from 'react'

function CategoryFilter (props) {
  //console.info(props)
  const [opened, setOpened] = useState(true)

  const checkboxes = () => {
    let list = []

    for (let category of props.categories) {
      //console.info(value)
      list.push(<div className={'checkbox'} key={category.id}>
        <label>
          <span className={'input-checkbox'}>
            <input type={'checkbox'} name={'category'} value={category.id} onChange={props.onChange}/>
            <span className="checkbox-text">
              <span>{category.hasOwnProperty('name') ? category.name : category.id}</span>&nbsp;
              <span className="count">{`(${category.count})`}</span>
            </span>
          </span>
        </label>
      </div>)
    }

    return list
  }

  return (
    <div className={`filter-box ${opened ? 'active' : ''}`} key={'categories'}>
      <div className={'filter-box__title'} onClick={() => (setOpened(!opened))}>{props.title}</div>
      <div className={`filter-box__container ${!opened ? 'collapsed' : ''}`}>
        <ul className={'filter-items-list'}>
          {checkboxes()}
        </ul>
      </div>
    </div>
  )
}

export default CategoryFilter